import { handleActions } from 'redux-actions';

import * as actions from './actions';
import * as base from "../BaseReducers";

const initialState = Object.assign({},
  base.ListState,
  base.DetailState,
  base.EditState,
);

export default handleActions(
  {
    [actions.balanceListLoadRequest]: (state, action) => base.listLoadRequest(state, action),
    [actions.balanceListLoadComplete]: (state, action) => base.listLoadComplete(state, action),
    [actions.balanceListLoadError]: (state, action) => base.listLoadError(state, action),

    [actions.balanceDetailLoadRequest]: (state, action) => base.detailLoadRequest(state, action),
    [actions.balanceDetailLoadComplete]: (state, action) => base.detailLoadComplete(state, action),
    [actions.balanceDetailLoadError]: (state, action) => base.detailLoadError(state, action),

    [actions.balanceUpdateRequest]: (state, action) => base.updateRequest(state, action),
    [actions.balanceUpdateComplete]: (state, action) => base.updateComplete(state, action),
    [actions.balanceUpdateError]: (state, action) => base.updateError(state, action),
  },
  initialState
);
